export const Prices = [
    {
      _id: 0,
      name: "Rs. 0 to 99",
      array: [0, 100],
    },
    {
      _id: 1,
      name: "Rs. 100 to 199",
      array: [100, 199],
    },
    {
      _id: 2,
      name: "Rs. 200 to 299",
      array: [200, 299],
    },
    {
      _id: 3,
      name: "Rs. 300 to 399",
      array: [300, 399],
    },
    {
      _id: 4,
      name: "Rs. 400 to 499",
      array: [400, 499],
    },
    {
      _id: 4,
      name: "Rs. 500 or more",
      array: [500, 9999],
    },
  ];